
<template>
  <div class="body-container my-relationship">
    <van-tabs v-model="searchParams.type" @change="getRelationShip">
      <van-tab title="推荐关系" name="1"></van-tab>
      <van-tab title="管理关系" name="2"></van-tab>
      <van-tab title="育成关系" name="3"></van-tab>
    </van-tabs>
    <relationshipTree class="tree-container" :list="treeData"></relationshipTree>
  </div>
</template>
<script>
import relationshipTree from './components/relationshipTree.vue';
import { common } from '@/api/mixins';
//当前实例组件
export default {
  components: {
    relationshipTree
  },
  mixins: [common],
  data: () => ({
    selfData: {},
    searchParams: {
      type: '1' //1-推荐关系 2-管理关系 3-育成关系
    },
    treeData: {}
  }),
  mounted() {
    if (!this.checkLogin()) {
      return;
    }
    this.searchParams.userId = JSON.parse(localStorage.getItem('jzy_user')).userId;
    this.getRelationShip();
  },
  methods: {
    getRelationShip() {
      this.$http({
        type: 'GET',
        url: '/api/userBase/queryRelation',
        data: this.searchParams
      }).then(res => {
        const arr = res.data;
        this.dealTree(arr);
        this.treeData = res.data;
        this.showItem(arr, this.selfData.id); // 展开自身数据的所有上级
        this.$nextTick(() => {
          if(this.selfData.children && this.selfData.children.length) {
            const last = this.selfData.children[this.selfData.children.length - 1];
            document.querySelector('#id' + last.id).scrollIntoView();
          }else{
            document.querySelector('#id' + this.selfData.id).scrollIntoView();
          }
        });
      });
    },
    showItem(arr, id) {
      if (!id) {
        return;
      }
      arr.forEach(item => {
        if (item.id == id) {
          item.hide = false;
          this.showItem(this.treeData, item.parentId);
        } else {
          this.showItem(item.children, id);
        }
      });
    },
    dealTree(arr) {
      let selfData;
      arr &&
        arr.forEach((item, index) => {
          if (arr[index + 1]) {
            item.hasNext = true;
          }
          item.hide = true;
          if (item.isSelf == 1) {
            selfData = item;
          }
          this.dealTree(item.children);
        });
      if (selfData) {
        this.selfData = selfData;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import './relationship.scss';
</style>
